import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ComposeMessageLauncherParams {
  category?: string;
  topic?: string;
}

export const COMPOSE_MESSAGE_LAUNCHER = new InjectionToken<
  (params?: ComposeMessageLauncherParams) => Observable<void>
>('COMPOSE_MESSAGE_LAUNCHER');
